import Vue from 'vue';
import { ISort } from '@/entities/sort.interface';
import { ICriterion } from '@/entities/criterion.interface';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import queryService from '@/services/query.service';
import { MasterPage } from './master-page';

export abstract class MasterPageCriteria extends MasterPage {
    public criteria: ICriterion[] = [];

    public selected: number[] = [];

    public abstract items: any[];

    public criteriaChange(criteria: ICriterion[]) {
        this.criteria = criteria;
        // this.page = 1;
        this.search();
    }

    public abstract list(body: ISearchBody): Promise<IPaging<any>>;

    protected search() {
        let body: ISearchBody = {
            page: this.page,
            pageSize: this.pageSize,
            criteria: this.criteria,
            sortField: this.sort.field,
            sortAsc: this.sort.asc
        };

        // this.total = 0;
        // this.items = [];
        this.selected = [];
        this.loading = true;
        return this.list(body)
            .then((response: IPaging<any>) => {
                this.loading = false;
                this.items = response.items;
                if (response.total !== null) {
                    this.total = response.total;
                }
            })
            .catch((err) => console.warn(err));
    }
}
